// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/Assets/Feeds/backgroundImg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BallotsPage{
    width: 100%;
    min-height: 100vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-color: #071414;
    color: white;
}
.ballotsPageContainer{
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}
.headerContain{
    z-index: 100000;
}
.ballotsPageContainer2{
    display: flex;
    width: 100%;
    min-height: calc(100vh - 12vh);
    position: relative;
}
.sidebarContain{
    position: fixed;
    left: 0%;
    top: 0;
    width: 20%;
    height: 100vh;
    background-color: rgba(14, 27, 27, 0.95);
    padding-top: 15vh;
    z-index: 1000;
    overflow-y: auto;
    padding-left: 16px;
    box-sizing: border-box;
    padding-right: 16px;
    border-right: 1px solid rgba(255, 255, 255, 0.08);
    /* Custom scrollbar styling */
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

/* Custom scrollbar for webkit browsers */
.sidebarContain::-webkit-scrollbar {
    width: 6px;
}

.sidebarContain::-webkit-scrollbar-track {
    background: transparent;
}

.sidebarContain::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
}

.sidebarContain::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.5);
}
.middleContainer{
    width: 46%;
    margin-left: 22%;
    margin-right: 28%;
    min-height: calc(100vh - 15vh);
    z-index: 1000;
    margin-top: 14vh;
    margin-bottom: 2vh;
}
.dashboardRightSectionContain{
    position: fixed;
    right: 0%;
    top: 16vh;
    width: 26%;
    height: calc(100vh - 15vh);
    z-index: 100;
    box-sizing: border-box;
    padding-left: 0px;
    padding-right: 1.5vw;
}

`, "",{"version":3,"sources":["webpack://./src/Pages/BallotsPage/BallotsPage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,yDAAuE;IACvE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;IAC5B,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,QAAQ;IACR,MAAM;IACN,UAAU;IACV,aAAa;IACb,wCAAwC;IACxC,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,iDAAiD;IACjD,6BAA6B;IAC7B,qBAAqB;IACrB,qDAAqD;AACzD;;AAEA,yCAAyC;AACzC;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;AAC9C;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,SAAS;IACT,SAAS;IACT,UAAU;IACV,0BAA0B;IAC1B,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;AACxB","sourcesContent":[".BallotsPage{\n    width: 100%;\n    min-height: 100vh;\n    background-image: url(\"../../../public/Assets/Feeds/backgroundImg.svg\");\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    background-color: #071414;\n    color: white;\n}\n.ballotsPageContainer{\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n.headerContain{\n    z-index: 100000;\n}\n.ballotsPageContainer2{\n    display: flex;\n    width: 100%;\n    min-height: calc(100vh - 12vh);\n    position: relative;\n}\n.sidebarContain{\n    position: fixed;\n    left: 0%;\n    top: 0;\n    width: 20%;\n    height: 100vh;\n    background-color: rgba(14, 27, 27, 0.95);\n    padding-top: 15vh;\n    z-index: 1000;\n    overflow-y: auto;\n    padding-left: 16px;\n    box-sizing: border-box;\n    padding-right: 16px;\n    border-right: 1px solid rgba(255, 255, 255, 0.08);\n    /* Custom scrollbar styling */\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\n}\n\n/* Custom scrollbar for webkit browsers */\n.sidebarContain::-webkit-scrollbar {\n    width: 6px;\n}\n\n.sidebarContain::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.sidebarContain::-webkit-scrollbar-thumb {\n    background-color: rgba(255, 255, 255, 0.3);\n    border-radius: 3px;\n}\n\n.sidebarContain::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(255, 255, 255, 0.5);\n}\n.middleContainer{\n    width: 46%;\n    margin-left: 22%;\n    margin-right: 28%;\n    min-height: calc(100vh - 15vh);\n    z-index: 1000;\n    margin-top: 14vh;\n    margin-bottom: 2vh;\n}\n.dashboardRightSectionContain{\n    position: fixed;\n    right: 0%;\n    top: 16vh;\n    width: 26%;\n    height: calc(100vh - 15vh);\n    z-index: 100;\n    box-sizing: border-box;\n    padding-left: 0px;\n    padding-right: 1.5vw;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
